import React from "react";
import { useSpring, animated } from "react-spring";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

const Loader = () => {
  const springProps = useSpring({
    from: { opacity: 0.6, transform: "scale(0.9)" },
    to: { opacity: 1, transform: "scale(1.1)" },
    loop: { reverse: true },
    config: { tension: 120, friction: 14 },
  });

  return (
    <Backdrop
      open={true}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        background: "rgba(0, 29, 61, 0.85)",
        backdropFilter: "blur(8px)",
      }}
    >
      <animated.div style={springProps}>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
          <CircularProgress
            size={56}
            thickness={4}
            sx={{
              color: "#00ff88",
              "& .MuiCircularProgress-circle": {
                strokeLinecap: "round",
              },
            }}
          />
        </Box>
      </animated.div>
    </Backdrop>
  );
};

export default Loader;
